import { render, staticRenderFns } from "./LeadsView.vue?vue&type=template&id=45246f3c&scoped=true&"
import script from "./LeadsView.vue?vue&type=script&lang=js&"
export * from "./LeadsView.vue?vue&type=script&lang=js&"
import style0 from "./LeadsView.vue?vue&type=style&index=0&id=45246f3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45246f3c",
  null
  
)

export default component.exports